import Faqs from "../components/Faq";
import facebook from '../assets/icons/facebook.svg'
import instagram from '../assets/icons/instagram.svg'
import tiktok from '../assets/icons/tiktok.svg'
import youtube from '../assets/icons/youtube.svg'
import { Link } from "react-router-dom";
import { motion } from "motion/react"
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from 'swiper/modules';



const Agric = () => {



  return (
    <div className="pt-[104px]">
      <div className="relative">
        <div className="sm:h-[50vh]">
          <div className="z-10 absolute inset-0 bg-black bg-opacity-40"></div>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={true}
            effect={'fade'}
            modules={[EffectFade, Autoplay]}
            className="h-full mySwiper"
          >
            <SwiperSlide>
              <img src={require('../assets/imgs/agric1.jpg')} alt='hero section background' className='block w-full h-full object-cover' />
            </SwiperSlide>
            <SwiperSlide>
              <img src={require('../assets/imgs/agric2.jpg')} alt='hero section background' className='block w-full h-full object-cover' />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className='top-1/2 left-1/2 z-20 absolute flex flex-col m-auto px-7 w-full md:w-3/4 overflow-hidden text-white -translate-x-1/2 -translate-y-1/2'>
          <motion.h1
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className='font-[PlayfairDisplay] font-semibold text-[40px] md:text-[60px] text-center'>Agricultural Investment</motion.h1>
          <motion.p
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className='font-[PlayfairDisplay] font-medium text-[20px] md:text-[20px] text-center'>Get To Know us</motion.p>
        </div>
      </div>
      <div className="mx-auto mt-9 mb-6 px-6 max-w-7xl">
        <div className="flex lg:flex-row flex-col items-center gap-[30px] md:gap-[100px] overflow-hidden">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="rounded-tr-[20px] rounded-bl-[20px] w-full h-[400px] overflow-hidden">
            <img src={require('../assets/imgs/agric3.jpg')} alt='hero section background' className='rounded-tr-[20px] rounded-bl-[20px] w-full h-full object-cover transition-transform duration-300 transform' />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="flex flex-col gap-4">

            <h1 className="font-[PlayfairDisplay] font-bold text-3xl md:text-4xl">AK-JODEM Agricultural Investment</h1>

            <p className="text-lg text-justify">
              Our agriculture division specializes
              in sustainable farming and food
              production. We offer services
              including farmland acquisition, the
              development of farmlands, farm
              management, and the growth,
              cultivation, and production of
              various agricultural produce.
            </p>
            <p className="text-lg text-justify">Our
              focus is on producing high-quality
              crops such as cassava, yam,
              cashew, maize, soya beans,
              potatoes, turmeric, and ginger for
              both local and international markets.
              Our team of experts is dedicated
              to providing our clients with
              innovative solutions that maximize
              yields and minimize waste.</p>
            <p className="text-lg text-justify">We believe in sustainable agriculture practices that support
              the health of the environment and the local community. Let us
              help you bring your agricultural visions to life.
            </p>



            <div className="flex justify-between items-center">
              <Link to="/Contact" className="bg-white hover:bg-[#c08b53] mt-6 lg:mt-0 px-6 py-3 border border-black hover:border-none rounded-lg font-semibold hover:text-white">
                Contact Us
              </Link>
              <div className="flex gap-3">
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.facebook.com/share/1Kbi7WK22q/?mibextid=wwXIfr'><img src={facebook} alt='facebook icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.instagram.com/ak_jodem?igsh=azB3aW43cHdhMnpu'><img src={instagram} alt='instagram icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.tiktok.com/@ak.jodem?_t=ZS-8vQHBpiryCu&_r=1'><img src={tiktok} alt='tiktok icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://m.youtube.com/@Akjodem'><img src={youtube} alt='youtube icon' className="h-[15px]" /></a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>


      </div>
    </div>
  );
};

export default Agric;
